module.exports = __webpack_public_path__ + "img/icon-pick-03.c0451aa0.svg";